import { render, staticRenderFns } from "./cercaClienti.html?vue&type=template&id=563d289f&"
import script from "./CercaClienti.vue?vue&type=script&lang=js&"
export * from "./CercaClienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports